import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const List = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px 0;

    & + & {
        border-top: 1px solid ${colors.borderSofter};
    }
`;

export const Line = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    min-width: 0;
`;

export const Name = styled.div`
    min-width: 0;
    overflow-wrap: anywhere;
`;

export const Amount = styled.div`
    white-space: nowrap;
`;

export const ModifierLine = styled(Line)`
    padding-left: 16px;
    color: ${colors.textSecondary};
    font-size: 13px;
`;

export const Discounted = styled.span`
    color: ${colors.success};
`;

export const Total = styled(Line)`
    padding-top: 12px;
    border-top: 1px solid ${colors.divider};
    font-weight: 600;
`;

export const Comment = styled.div`
    color: ${colors.textSecondary};
    font-size: 13px;
`;
